/**
 * Avatar Matrix — single source of truth for vestuario × ambiente × resolución × plano.
 *
 * Cada foto subida a HeyGen representa una combinación única.
 * El `photoId` es el talking_photo_id que se envía en el payload.
 * El `url` es la URL de preview para los selectors.
 *
 * Convención de naming: {vestuario}-{ambiente}-{resolucion}-{plano}
 * Ejemplo: argentina-cafe-16-9-medio
 */

export type Resolucion = '16:9' | '9:16';
export type Plano = 'medio' | 'pecho' | 'entero' | 'lejano';

export interface AvatarEntry {
  vestuario: string;
  ambiente: string;
  resolucion: Resolucion;
  plano: Plano;
  photoId: string;
  url: string;
}

export const AVATAR_MATRIX: AvatarEntry[] = [
  // ── argentina × cafe ──
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '83840cf99ab24f40aa998f017fa87408',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-16-9-medio/image-jpeg/argentina-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'ec020310fec3415994e95a1c32417f20',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-16-9-pecho/image-jpeg/argentina-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '97c0095858f74612890f3a40503890b1',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-16-9-entero/image-jpeg/argentina-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '8f605c846fd94c12a07610b6c2a10926',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-9-16-medio/image-jpeg/argentina-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'd4f76532c6ea42fa943e99c665b862df',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-9-16-pecho/image-jpeg/argentina-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '5ea4833db5174853906e0ed61c586b88',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-cafe-9-16-entero/image-jpeg/argentina-cafe-9-16-entero-optimized.png`
  },

  // ── argentina × digital ──
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '4290a0e3e8ae4f96ba827189b14b632b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-16-9-lejano/image-jpeg/argentina-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '65ac157f6c8c49caa510e187964b5729',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-16-9-medio/image-jpeg/argentina-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'ee074f65defe4161b58e87ec13d5942b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-16-9-pecho/image-jpeg/argentina-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '6f7ab0decd9f46189d74c928426afc05',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-16-9-entero/image-jpeg/argentina-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '344dca6f11244a539789cbc2f385f15e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-9-16-lejano/image-jpeg/argentina-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '52958c7b13bc43d7a0c37d80d0044795',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-9-16-medio/image-jpeg/argentina-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '32eaa7301f464b218c9200977046315d',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-9-16-pecho/image-jpeg/argentina-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '79f18e4cf0954655a8cd76c40bce9087',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-digital-9-16-entero/image-jpeg/argentina-digital-9-16-entero-optimized.png`
  },

  // ── argentina × hogar ──
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: 'faa8e3f33d8146ef94b0964e0228cf6f',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-16-9-lejano/image-jpeg/argentina-hogar-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '5b8f373012f14678884c2d4ad8c9c651',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-16-9-medio/image-jpeg/argentina-hogar-16-9-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '437d7c01989241e3a35ec4fcc72712ed',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-16-9-pecho/image-jpeg/argentina-hogar-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'b209dfa1a904475db2ad4a00e5029891',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-16-9-entero/image-jpeg/argentina-hogar-16-9-entero-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '0c3de85f78c249cd9b2cadf01e09173c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-9-16-lejano/image-jpeg/argentina-hogar-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '30559cb5426347adaa0d8195aae6c905',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-9-16-medio/image-jpeg/argentina-hogar-9-16-medio-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '88773ff13eed4ffc980ea5c21ea550be',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-9-16-pecho/image-jpeg/argentina-hogar-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'argentina',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'be52d08e08f343b9a6f3198fd29b10dd',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/argentina-hogar-9-16-entero/image-jpeg/argentina-hogar-9-16-entero-optimized.png`
  },

  // ── blazer azul × institucional ──
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'f2bff4e30cd04820a1bdbe1d412d8123',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-16-9-medio/image-jpeg/blazerazul-entradamacro-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'd8c8fef3f5c5490e93d31b9c6edbda17',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-16-9-pecho/image-jpeg/blazerazul-entradamacro-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '013d33b6e4c143dcbf377bfe8fdc6418',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-16-9-entero/image-jpeg/blazerazul-entradamacro-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'bd0e39d1d58e48568baed64920dd2441',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-9-16-medio/image-jpeg/blazerazul-entradamacro-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'bb47f83d5e9b4ea8abf440a17d9cc368',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-9-16-pecho/image-jpeg/blazerazul-entradamacro-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer azul',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'abc30ba983b64705afba12f56223ecfa',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerazul-entradamacro-9-16-entero/image-jpeg/blazerazul-entradamacro-9-16-entero-optimized.png`
  },

  // ── blazer beige × digital ──
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '76d79f95f853452fab332e8059481dfd',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-16-9-lejano/image-jpeg/blazerbeige-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'b972fc183911405fb4297ff26052d544',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-16-9-medio/image-jpeg/blazerbeige-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '5e9e26337f8f48e5b8490423d7a5304f',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-16-9-pecho/image-jpeg/blazerbeige-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'e67d1d1507534c7280398cf42ad0524e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-16-9-entero/image-jpeg/blazerbeige-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: 'f8cd65e5f6ba48248e6ba449ecefe0d3',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-9-16-lejano/image-jpeg/blazerbeige-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '9f125b724d344da08075931004295141',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-9-16-medio/image-jpeg/blazerbeige-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '32fd3e7ac38a400c872e99171784f1f0',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-9-16-pecho/image-jpeg/blazerbeige-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '339b89b797b34b6e80fd5632f91e4354',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-digital-9-16-entero/image-jpeg/blazerbeige-digital-9-16-entero-optimized.png`
  },

  // ── blazer beige × institucional ──
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'bbd05209db0945559afb4bea2283e7ee',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-16-9-medio/image-jpeg/blazerbeige-entradamacro-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'e307edbcf2574d4086d4040252f3479e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-16-9-pecho/image-jpeg/blazerbeige-entradamacro-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'e52aa8810d694ed8833eed4f30dd4cb0',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-16-9-entero/image-jpeg/blazerbeige-entradamacro-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '84e712cb166141f2b106e9512c8c1c64',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-9-16-medio/image-jpeg/blazerbeige-entradamacro-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'ec663eeaad2e458aa994cc322ff5cf92',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-9-16-pecho/image-jpeg/blazerbeige-entradamacro-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '422e3879e3604edeb797677baf1ea0f1',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-entradamacro-9-16-entero/image-jpeg/blazerbeige-entradamacro-9-16-entero-optimized.png`
  },

  // ── blazer beige × urban garden ──
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'ca9e33c3c9be4d7d8e7cb737147e1ce8',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-16-9-medio/image-jpeg/blazerbeigeremeranegra-escalera-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '7c46a05e6e1e4817b6a378c1425fb2ec',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-16-9-pecho/image-jpeg/blazerbeigeremeranegra-escalera-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'bd3d055c16f64c87a57bf550afbb1e07',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-16-9-entero/image-jpeg/blazerbeigeremeranegra-escalera-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '43175e000f724908b14627c2b0368338',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-9-16-medio/image-jpeg/blazerbeigeremeranegra-escalera-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '507e1fb368764df98cee0a15cac753dc',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-9-16-pecho/image-jpeg/blazerbeigeremeranegra-escalera-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '9ec58aff69724545b5289950a8be4111',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeigeremeranegra-escalera-9-16-entero/image-jpeg/blazerbeigeremeranegra-escalera-9-16-entero-optimized.png`
  },

  // ── blazer beige × sucursal ──
  {
    vestuario: 'blazer beige',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '5f9b38e81df546788325d1b688852d5b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-sucursal-16-9-entero/image-jpeg/blazerbeige-sucursal-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'bb02d4c3266946f0a67d4eb171ffd361',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-sucursal-16-9-medio/image-jpeg/blazerbeige-sucursal-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '3bf1942930184aec85643ac1739ad80b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-sucursal-16-9-pecho/image-jpeg/blazerbeige-sucursal-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'sucursal',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '07d50ec7d64640088522efe05421670c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-sucursal-9-16-medio/image-jpeg/blazerbeige-sucursal-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer beige',
    ambiente: 'sucursal',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'c4534e1c726e4998b9abc25a83837247',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerbeige-sucursal-9-16-pecho/image-jpeg/blazerbeige-sucursal-9-16-pecho-optimized.png`
  },

  // ── blazer celeste × cafe ──
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '4693c14773434956806017431df75565',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-16-9-medio/image-jpeg/blazerceleste-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'eefe7c7413084f9988216ac175ad64e2',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-16-9-pecho/image-jpeg/blazerceleste-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'f4c4a8cba027434fb8bf451cbee38d13',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-16-9-entero/image-jpeg/blazerceleste-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '6b92480fe88f40769f06304eb2f41afb',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-9-16-medio/image-jpeg/blazerceleste-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '73f886684ef946789ecfbfe59a39af67',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-9-16-pecho/image-jpeg/blazerceleste-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '9d349a4f9a964fa29600ea1a921bd4e3',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-cafe-9-16-entero/image-jpeg/blazerceleste-cafe-9-16-entero-optimized.png`
  },

  // ── blazer celeste × digital ──
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '1838ba0ae1a247ed8b80a181ae07a8c4',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-16-9-lejano/image-jpeg/blazerceleste-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'eb80c2c626a4474680cf850684c11d71',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-16-9-medio/image-jpeg/blazerceleste-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'd11f3616dd674a9eac2598db18b259ab',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-16-9-pecho/image-jpeg/blazerceleste-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '667d9fa2f9134d59b6978c1a435e120b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-16-9-entero/image-jpeg/blazerceleste-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '5d1ae3ca9b7b4a8891b8122610aef67e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-9-16-lejano/image-jpeg/blazerceleste-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '1482d4fb81b84796b845445ffbf31dca',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-9-16-medio/image-jpeg/blazerceleste-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '96b0eec4d7184102b107bea3231d1e42',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-9-16-pecho/image-jpeg/blazerceleste-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '606d702ffdcf4364a0cfdd365e1c8d4c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-digital-9-16-entero/image-jpeg/blazerceleste-digital-9-16-entero-optimized.png`
  },

  // ── blazer celeste × institucional ──
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'c7d25cf0e43545c085c3ee7cc33a79ed',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-16-9-medio/image-jpeg/blazerceleste-entradamacro-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '1ac2f898a52845f6b2fcce6ef6a040fa',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-16-9-pecho/image-jpeg/blazerceleste-entradamacro-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'eb5bc2294f8f4e9693bc77811650f9db',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-16-9-entero/image-jpeg/blazerceleste-entradamacro-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '8dab21116ee54c9ba1290fa9a8767d7e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-9-16-medio/image-jpeg/blazerceleste-entradamacro-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '3c2036cc79fa4a1581d8878d7fc63651',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-9-16-pecho/image-jpeg/blazerceleste-entradamacro-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'e6a8de922d224979b0496bf9bd8e9f71',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-entradamacro-9-16-entero/image-jpeg/blazerceleste-entradamacro-9-16-entero-optimized.png`
  },

  // ── blazer celeste × urban garden ──
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '716fedffd026468e9e5c71e6632c0a84',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-16-9-medio/image-jpeg/blazercelesteremerablanca-escalera-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'e2bc47d65ffb43308848743ad9cfcbcb',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-16-9-pecho/image-jpeg/blazercelesteremerablanca-escalera-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '42136cf8b9e2495fa785a1a3462c67fc',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-16-9-entero/image-jpeg/blazercelesteremerablanca-escalera-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '4af12cc026f0469aa1f88728d695e29b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-9-16-medio/image-jpeg/blazercelesteremerablanca-escalera-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'cc75a4253fa943529893767532fd0525',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-9-16-pecho/image-jpeg/blazercelesteremerablanca-escalera-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'urban garden',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '56436e78c91f45e49d687a4c72b9bc03',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazercelesteremerablanca-escalera-9-16-entero/image-jpeg/blazercelesteremerablanca-escalera-9-16-entero-optimized.png`
  },

  // ── blazer celeste × sucursal ──
  {
    vestuario: 'blazer celeste',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'a008adea73e04f369b26ac8c894de80c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-sucursal-16-9-entero/image-jpeg/blazerceleste-sucursal-16-9-entero-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'd31b96cccf3848d8b5f3e9c808041448',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-sucursal-16-9-medio/image-jpeg/blazerceleste-sucursal-16-9-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'sucursal',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '912f5469fba142a08e2a83e692107fc0',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-sucursal-16-9-pecho/image-jpeg/blazerceleste-sucursal-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'sucursal',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '42a7a687e85e494a874d37d2807febf4',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-sucursal-9-16-medio/image-jpeg/blazerceleste-sucursal-9-16-medio-optimized.png`
  },
  {
    vestuario: 'blazer celeste',
    ambiente: 'sucursal',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '7e55924ed8dd4d988eccf49463740eb4',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/blazerceleste-sucursal-9-16-pecho/image-jpeg/blazerceleste-sucursal-9-16-pecho-optimized.png`
  },

  // ── camisa blanca × institucional ──
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '2a7e96d9501a4172b00ee5a60d368402',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-16-9-medio/image-jpeg/camisablanca-entradamacro-16-9-medio-optimized.png`
  },
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '47e3cc1db4ee486585d9588dbad860a6',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-16-9-pecho/image-jpeg/camisablanca-entradamacro-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '8093728bf9434ad5809d52b25a86d2c1',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-16-9-entero/image-jpeg/camisablanca-entradamacro-16-9-entero-optimized.png`
  },
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '701b55a18178490ea7522750094d8623',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-9-16-medio/image-jpeg/camisablanca-entradamacro-9-16-medio-optimized.png`
  },
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '8886973b11214fbe9af2ff8245d05786',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-9-16-pecho/image-jpeg/camisablanca-entradamacro-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'camisa blanca',
    ambiente: 'institucional',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '69d0413a7a924ac7aab623650b6e9332',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisablanca-entradamacro-9-16-entero/image-jpeg/camisablanca-entradamacro-9-16-entero-optimized.png`
  },

  // ── camisa jean × cafe ──
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'd02dca22c6f543388f817ef96e333af8',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-16-9-medio/image-jpeg/camisajean-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'be0fe1c3a2a24d35a8510dec19765a07',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-16-9-pecho/image-jpeg/camisajean-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'f77c0c28caf64d3d848742fbd263249a',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-16-9-entero/image-jpeg/camisajean-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'eafc8b9be5814ab39a72db3327a42549',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-9-16-medio/image-jpeg/camisajean-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'cd82fcfc2cc94b3ba1992ee72493a58d',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-9-16-pecho/image-jpeg/camisajean-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '1f1f60982527445ca4bd620b5661f3c9',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-cafe-9-16-entero/image-jpeg/camisajean-cafe-9-16-entero-optimized.png`
  },
  // ── camisa jean × digital ──
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '4fee745fe15e425d8f60c81060e44b38',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-16-9-lejano/image-jpeg/camisajean-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '9866ef633fd042a2b686c67a5155f932',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-16-9-medio/image-jpeg/camisajean-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '6b9058555f8649b59bd2a678f84c514f',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-16-9-pecho/image-jpeg/camisajean-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'a8f708e5cbd143d3a50808b6030fcd8b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-16-9-entero/image-jpeg/camisajean-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '98a2753da6534cb78e11407d9b6a50c9',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-9-16-lejano/image-jpeg/camisajean-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '8ab1ed15c7bc4698bce2c59f8c75c335',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-9-16-medio/image-jpeg/camisajean-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'addcca5fe2e9448481cbd16cc8e5ec09',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-9-16-pecho/image-jpeg/camisajean-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'a112f586c1e24b88b7de51fe5e3e28c7',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/camisajean-digital-9-16-entero/image-jpeg/camisajean-digital-9-16-entero-optimized.png`
  },

  // ── camisa jean × hogar ──
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '068aac8f748e4e5e98ffa2759b09c775',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-16-9-lejano/image-jpeg/jean-hogar-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'bf3d60e078f543e5875ffe4827686f5b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-16-9-medio/image-jpeg/jean-hogar-16-9-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '78ae9ff960d84e71931df777e1f1be16',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-16-9-pecho/image-jpeg/jean-hogar-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '1763d9f1f0374bc7a650e5bad327accb',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-16-9-entero/image-jpeg/jean-hogar-16-9-entero-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '67069d6b008d480eacb9cc02a4f25105',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-9-16-lejano/image-jpeg/jean-hogar-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'a4ae5601ce274652a988230a81945e4b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-9-16-medio/image-jpeg/jean-hogar-9-16-medio-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '5b21ef21384146e3a38a264f5273eb06',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-9-16-pecho/image-jpeg/jean-hogar-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'camisa jean',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '118257cae1be46e5abb0e119c64ed074',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jean-hogar-9-16-entero/image-jpeg/jean-hogar-9-16-entero-optimized.png`
  },

  // ── jean chaqueta × cafe ──
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '4c426d0c52b14884ab2d7902acd044b4',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-16-9-medio/image-jpeg/jeanchaqueta-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '40c7d0e821b045a39949c4203b18340b',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-16-9-pecho/image-jpeg/jeanchaqueta-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'daccfd3159224777b8782df159387466',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-16-9-entero/image-jpeg/jeanchaqueta-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '6d8051d6e51044a4ba163af0025c99ee',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-9-16-medio/image-jpeg/jeanchaqueta-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'af75e7fb83ea4594b6342f3524aab95c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-9-16-pecho/image-jpeg/jeanchaqueta-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '21979135e17442559975e9c321f601fd',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-cafe-9-16-entero/image-jpeg/jeanchaqueta-cafe-9-16-entero-optimized.png`
  },

  // ── jean chaqueta × digital ──
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '5d0645f4cad44fa19989f84c2c30964a',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-16-9-lejano/image-jpeg/jeanchaqueta-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '1c8bacf5c0754381ad165e9dbbffd3be',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-16-9-medio/image-jpeg/jeanchaqueta-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '6f9a050d57f9462fb2093fd502ba0825',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-16-9-pecho/image-jpeg/jeanchaqueta-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'eaa76bad2a044c5b99ac1286d7dbb5f7',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-16-9-entero/image-jpeg/jeanchaqueta-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '702b618f308e42619f5f794e1fe9551e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-9-16-lejano/image-jpeg/jeanchaqueta-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'e75a87ff4c144df9be46dd9b5a4e77ed',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-9-16-medio/image-jpeg/jeanchaqueta-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'd8b1a55d38b94e519dcaec99bdb81bf5',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-9-16-pecho/image-jpeg/jeanchaqueta-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'e112549b214442edaf562b450d8abf56',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaqueta-digital-9-16-entero/image-jpeg/jeanchaqueta-digital-9-16-entero-optimized.png`
  },

  // ── jean chaqueta × hogar ──
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: 'bcf521accf6c40babc8172aa29ae0a68',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-16-9-lejano/image-jpeg/jeanchaquetanegra-hogar-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '8c7c5778a5b8489c8ca6c1ac54032017',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-16-9-medio/image-jpeg/jeanchaquetanegra-hogar-16-9-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '5dd3b4d6647b4713a57e59a89be73b34',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-16-9-pecho/image-jpeg/jeanchaquetanegra-hogar-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '959802d227054a91be4cb98ad3d7da89',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-16-9-entero/image-jpeg/jeanchaquetanegra-hogar-16-9-entero-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '49619c4929074b56aab215b4b84ca207',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-9-16-lejano/image-jpeg/jeanchaquetanegra-hogar-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'medio',
    photoId: '5bbca25877b64084a9ab39cb88c663a3',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-9-16-medio/image-jpeg/jeanchaquetanegra-hogar-9-16-medio-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '364e33d8dab14e4397586cbbf17d4961',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-9-16-pecho/image-jpeg/jeanchaquetanegra-hogar-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'jean chaqueta',
    ambiente: 'hogar',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '734e7cb51ce34784a5047303a280ec94',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/jeanchaquetanegra-hogar-9-16-entero/image-jpeg/jeanchaquetanegra-hogar-9-16-entero-optimized.png`
  },

  // ── remera blanca × cafe ──
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '4b22d3259434480b8d9f02a9bb44e919',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-16-9-medio/image-jpeg/remerablanca-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'ec1d2bb90fa2412785ab296f5a343f37',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-16-9-pecho/image-jpeg/remerablanca-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'f105bde4dbfb457bb04d09cf0745f54c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-16-9-entero/image-jpeg/remerablanca-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'ef727c920a7d40adb20981b31640a227',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-9-16-medio/image-jpeg/remerablanca-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'd9f04d1d4610436ab096260890aafc7c',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-9-16-pecho/image-jpeg/remerablanca-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'remera blanca',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '3771b0721aa845beba3d7e5c067ae62a',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/remerablanca-cafe-9-16-entero/image-jpeg/remerablanca-cafe-9-16-entero-optimized.png`
  },

  // ── sweater crema × cafe ──
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'medio',
    photoId: 'ee463a04afc646f092b0a14db988140a',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-16-9-medio/image-jpeg/swetercremita-cafe-16-9-medio-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: '3106037d672b48b7b190aebf7fd5b87a',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-16-9-pecho/image-jpeg/swetercremita-cafe-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '16:9',
    plano: 'entero',
    photoId: '15780f0bba9443a0b368caff358e467e',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-16-9-entero/image-jpeg/swetercremita-cafe-16-9-entero-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'bf9f723aa80b4e4da05b398755b13859',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-9-16-medio/image-jpeg/swetercremita-cafe-9-16-medio-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: 'cf757f139b214ab7b32c7cdac86c28ab',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-9-16-pecho/image-jpeg/swetercremita-cafe-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'cafe',
    resolucion: '9:16',
    plano: 'entero',
    photoId: '6e3be501acb743f4acf6e9e86e30d628',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swetercremita-cafe-9-16-entero/image-jpeg/swetercremita-cafe-9-16-entero-optimized.png`
  },

  // ── sweater crema × digital ──
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'lejano',
    photoId: '789ee8a114aa42b0ac35cf753911a5ee',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-16-9-lejano/image-jpeg/swettercrema-digital-16-9-lejano-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'medio',
    photoId: '7d77827e5d274c949d07628dc17b01a1',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-16-9-medio/image-jpeg/swettercrema-digital-16-9-medio-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'pecho',
    photoId: 'd7fe7587889b44e78d1bd3ab0d4dc420',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-16-9-pecho/image-jpeg/swettercrema-digital-16-9-pecho-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '16:9',
    plano: 'entero',
    photoId: 'b3f52b98ae974c319b7f4603f4d15ec5',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-16-9-entero/image-jpeg/swettercrema-digital-16-9-entero-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'lejano',
    photoId: '7aafd79ead2742c181a5015e4a028fdc',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-9-16-lejano/image-jpeg/swettercrema-digital-9-16-lejano-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'medio',
    photoId: 'f27c65fed5d44f42ba7fd2662477ec80',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-9-16-medio/image-jpeg/swettercrema-digital-9-16-medio-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'pecho',
    photoId: '11653e23723246f3b4206b7d55450ff8',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-9-16-pecho/image-jpeg/swettercrema-digital-9-16-pecho-optimized.png`
  },
  {
    vestuario: 'sweater crema',
    ambiente: 'digital',
    resolucion: '9:16',
    plano: 'entero',
    photoId: 'c3c4aad632ab419299f2e473392e7745',
    url: `${process.env.REACT_APP_MEDIA_DOMAIN}/avatars/assets/TEST/swettercrema-digital-9-16-entero/image-jpeg/swettercrema-digital-9-16-entero-optimized.png`
  }
];
